export type V2LocaleCode = 'pt_BR' | 'en' | 'es' | 'zh_CN';

export type V2LocaleOption = {
    code: V2LocaleCode;
    label: string;
    flagCode: string;
};

/** Paridade com FilamentLanguageSwitcherPlugin (AdminPanelProvider). */
export const V2_LOCALES: V2LocaleOption[] = [
    { code: 'pt_BR', label: 'Português', flagCode: 'br' },
    { code: 'en', label: 'Inglês', flagCode: 'us' },
    { code: 'es', label: 'Español', flagCode: 'es' },
    { code: 'zh_CN', label: 'Chinês', flagCode: 'cn' },
];

export function flagUrl(flagCode: string): string {
    return `/img/v2/flags/1x1-${flagCode}.svg`;
}

export function resolveV2Locale(code?: string | null): V2LocaleOption {
    return V2_LOCALES.find((l) => l.code === code) ?? V2_LOCALES[0];
}
